/**
 * v4.15.0 — Day-group helpers.
 *
 * Quick toggles that match how operators think about days: Weekdays,
 * Weekends, All, None. Each preset sets the day selection on a single
 * block. The atomic per-day chips remain available for fine control.
 */

const GROUPS = [
    { id: 'weekdays', label: 'Weekdays', days: ['mon', 'tue', 'wed', 'thu', 'fri'] },
    { id: 'weekends', label: 'Weekends', days: ['sat', 'sun'] },
    { id: 'all',      label: 'All',      days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] },
    { id: 'none',     label: 'None',     days: [] },
];

export default function DayGroupHelpers({ disabled, onSet, blockIndex }) {
    return (
        <div
            className="flex flex-wrap gap-1 ml-0.5"
            data-testid={`day-group-helpers-${blockIndex}`}
        >
            {GROUPS.map(g => (
                <button
                    key={g.id}
                    type="button"
                    disabled={disabled}
                    onClick={() => onSet(g.days)}
                    data-testid={`day-group-${blockIndex}-${g.id}`}
                    className="h-6 px-2 rounded text-[10px] font-medium border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-600 dark:text-slate-300 hover:border-cyan-400 hover:bg-cyan-50 dark:hover:bg-cyan-950/30 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                >
                    {g.label}
                </button>
            ))}
        </div>
    );
}
